import { render, staticRenderFns } from "./prodautoconfig.vue?vue&type=template&id=3a299ef5&scoped=true&"
import script from "./prodautoconfig.vue?vue&type=script&lang=js&"
export * from "./prodautoconfig.vue?vue&type=script&lang=js&"
import style0 from "./prodautoconfig.vue?vue&type=style&index=0&id=3a299ef5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a299ef5",
  null
  
)

export default component.exports